module.exports = __webpack_public_path__ + "img/elecciones20216.84862b18.jpg";